import { useEffect, useState, useMemo } from "react";
import {
  Box,
  Grid,
  Typography,
  Container,
  Card,
  CardContent,
  ToggleButton,
  ToggleButtonGroup,
  TextField,
  Stack,
  Divider,
  Button,
  FormControlLabel,
  Checkbox,
  useMediaQuery,
  useTheme
} from "@mui/material";

import { useSelector, useDispatch } from "react-redux";
import PhoneVerifyInReservation from "../userProfile/phoneVerifyInReservation";
import PaymentMethods from "src/sections/payment/ReservationPaymentMethods";
import { useSnackbar } from 'src/components/snackbar';
import { useNavigate } from "react-router";
import axios from "axios";
import { LoadingButton } from "@mui/lab";
import { getVenue } from "src/redux/slices/venueSlice";
import { Icon } from "@iconify/react";
import plusIcon from "@iconify-icons/mdi/plus";
import minusIcon from "@iconify-icons/mdi/minus";
import { fNumber } from "src/utils/formatNumber";




const ReservationCheckoutSummary = (selectedSlot) => {
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    async function fetchData() {
      if (selectedSlot?.checkView == true) {
        await dispatch(getVenue(selectedSlot?.selectedSlot?.venueId));
      } else {
        await dispatch(getVenue(selectedSlot?.selectedSlot?.tableInfo?.areaId?.venueId));
      }
    }
    fetchData();

  }, [selectedSlot?.tableInfo?.areaId?.venueId]);

  const { venue } = useSelector((state) => state.venue);
  const { user, isLoggedIn } = useSelector((state) => state.login);
  const [specialRequest, setSpecialRequest] = useState("");
  const [occasion, setOccasion] = useState("none");
  const [showFullNote, setShowFullNote] = useState(false);
  const [showFullPolicy, setShowFullPolicy] = useState(false);
  const [checked, setChecked] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };

  const handleSpecialRequestChange = (e) => {
    setSpecialRequest(e.target.value);
  };

  const handleOccasionChange = (event, newOccasion) => {
    setOccasion(newOccasion);
  };

  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getUTCDate()).padStart(2, '0');
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const year = String(date.getUTCFullYear());

    return `${year}-${month}-${day}`;
  }

  function formatDateInStringFormate(dateString) {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  }

  const onSubmit = async () => {
    setIsLoading(true);

    const getToken = localStorage.getItem("access_token");
    try {

      let data
      if (selectedSlot?.checkView == true) {
        data = {
          partySize: parseInt(selectedSlot?.selectedTableSize, 10),
          date: formatDate(selectedSlot?.selectedSlot?.startingTime),
          venueId: selectedSlot?.selectedSlot?.venueId,
          levelId: selectedSlot?.selectedSlot?.levelId,
          startTime: selectedSlot?.selectedSlot?.startingTime,
          endTime: selectedSlot?.selectedSlot?.endingTime,
          tableId: selectedSlot?.selectedSlot?.tableId,
          origin: "web",
          reservationType: "online",
          areaId: selectedSlot?.selectedSlot?.areaId?.id,
          customerId: user?.id,
          occasion: occasion,
          specialRequest: specialRequest
        }
      } else {
        data = {
          partySize: parseInt(selectedSlot?.selectedTableSize, 10),
          date: formatDate(selectedSlot?.selectedSlot?.startingTime),
          venueId: selectedSlot?.selectedSlot?.venueId,
          levelId: selectedSlot?.selectedSlot?.levelId,
          startTime: selectedSlot?.selectedSlot?.startingTime,
          endTime: selectedSlot?.selectedSlot?.endingTime,
          tableId: selectedSlot?.selectedSlot?.tableId,
          origin: "web",
          reservationType: "online",
          areaId: selectedSlot?.selectedSlot?.areaId?.id,
          customerId: user?.id,
          occasion: occasion,
          specialRequest: specialRequest
        }
      }
      const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/reservation/b2c`,
        data,
        {
          headers: {
            Authorization: `Bearer ${getToken}`,
          },
        }

      );
      if (response.status === 201) {
        enqueueSnackbar("Reservation add successfully");
        setIsLoading(false);
        navigate(`/reservation`);
      }
    } catch (error) {
      setIsLoading(false);
      enqueueSnackbar(error?.response?.data?.message, { variant: 'error' });
    };
  }
  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getUTCDate()).padStart(2, '0');
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const year = String(date.getUTCFullYear());

    return `${year}-${month}-${day}`;
  }
  function formatTime(TimeString) {
    const date = new Date(TimeString);
    const hours = date.getUTCHours() % 12 || 12;
    const minutes = date.getUTCMinutes().toString().padStart(2, '0');
    const ampm = date.getUTCHours() >= 12 ? 'pm' : 'am';
    return `${hours}:${minutes} ${ampm}`;
  }

  const truncateText = (text, limit) => {
    return text?.length > limit ? text?.substring(0, limit) + "..." : text;
  };

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <>
      <Box
        sx={{
          p: {
            lg: "0px 50px 0px 50px",
            xl: "0px 50px 0px 50px",
          }
        }}
      >
        <Container maxWidth="xl" sx={{ marginTop: 3, marginBottom: 3 }}>

          <Card sx={{
            width: '100%',
            border: "1px solid rgba(0, 0, 0, 0.10)",
            borderRadius: "16px",
          }}>
            <Grid
              container
              spacing={3}
              sx={{
                marginTop: '5px',
                alignItems: "stretch",
                flexDirection: isMobile ? "column-reverse" : "row",
              }}
            >
              <Grid item xs={12} md={6}>
                <Box>
                  <Typography
                    variant="h5"
                    sx={{
                      fontWeight: "700",
                      marginLeft: "14px",
                      fontSize: "20px",
                      marginTop: isLoggedIn ? "0px" : "80px",
                      "@media (max-width: 600px)": {
                        marginTop: "0px"
                      },
                      marginBottom: "10px",

                    }}
                  >
                    Personal Information
                  </Typography>
                  {(!user?.phone) ?
                    <>
                      <Box sx={{ paddingLeft: 2 }}>
                        <Typography variant="body1" color="error">
                          Please add and verify your phone number before booking reservation.
                        </Typography>
                      </Box>
                    </>
                    : (user?.phone && !user?.isPhoneVerified) ?
                      <>
                        <Box sx={{ paddingLeft: 2 }}>
                          <Typography variant="body1" color="error">
                            Please verify your phone number before booking reservation.
                          </Typography>
                        </Box>
                      </> : null
                  }
                </Box>

                <Stack spacing={2}>
                  <Box
                    sx={{
                      p: 2,
                      maxWidth: 600,
                      margin: "0 auto",
                    }}
                  >

                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={12}>
                        <PhoneVerifyInReservation context="ReservationCheckoutSummary" />
                      </Grid>
                    </Grid>
                  </Box>
                  <Box
                    sx={{
                      p: 2,
                      maxWidth: 600,
                    }}
                  >
                    <Typography
                      variant="h5"
                      sx={{
                        fontWeight: "700",
                        fontSize: "20px",
                        marginBottom: "10px",
                      }}
                    >
                      Any special request?
                    </Typography>
                    <TextField
                      placeholder="Add special request here..."
                      multiline
                      rows={4}
                      value={specialRequest}
                      onChange={handleSpecialRequestChange}
                      fullWidth
                    />
                  </Box>

                  <Box
                    sx={{
                      p: 2,
                      maxWidth: 600,
                    }}
                  >
                    <Typography
                      variant="h5"
                      sx={{
                        fontWeight: "700",
                        fontSize: "20px",
                        marginBottom: "10px",

                      }}
                    >
                      What's the occasion?
                    </Typography>
                    <ToggleButtonGroup
                      value={occasion}
                      exclusive
                      onChange={handleOccasionChange}
                      aria-label="occasion"
                      sx={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: 0.5,
                        border: "1px solid rgba(14, 14, 14, 0.1)",
                        borderRadius: "10px",
                      }}
                    >
                      {['birthday', 'anniversary', 'casualMeetup', 'businessMeeting', 'familyGathering', 'other'].map((value) => (
                        <ToggleButton
                          key={value}
                          value={value}
                          aria-label={value}
                          sx={{
                            backgroundColor: "rgba(85, 83, 83, 0.1)",
                            color: occasion === value ? "black" : "inherit",
                            padding: "8px 16px",
                            fontWeight: "600",
                            transition: "all 0.3s ease-in-out",
                            "&:hover": {
                              backgroundColor: occasion === value ? "#FCA92E" : "#f0f0f0",
                              borderColor: "#999",
                            },
                            "&.Mui-selected": {
                              backgroundColor: "#F59B34",
                              color: "black",
                              borderColor: "#F59B34",
                              "&:hover": {
                                backgroundColor: "#FCA92E",
                              },
                            },
                          }}
                        >
                          <span
                            style={{
                              padding: "1px 2px",
                              borderRadius: "4px",
                            }}
                          >
                            {value.replace(/([a-z])([A-Z])/g, "$1 $2")}
                          </span>
                        </ToggleButton>
                      ))}
                    </ToggleButtonGroup>
                  </Box>

                  {venue?.reservationAdvanceAmount?.isRequired && <Box
                    sx={{
                      p: 2,
                      maxWidth: 600,
                    }}
                  >
                    <Typography
                      variant="h5"
                      sx={{
                        fontWeight: "700",
                        fontSize: "20px",
                        marginBottom: "10px",
                      }}
                    >
                      Reservation summary
                    </Typography>

                    <Box>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          marginBottom: "10px",
                        }}
                      >
                        <Typography>{venue?.reservationAdvanceAmount?.type == 'fixed' ? 'Fixed Amount' : 'Per Person Amount'}</Typography>
                        <Typography>Rs {fNumber(venue?.reservationAdvanceAmount?.amount)}</Typography>
                      </Box>
                      {venue?.reservationAdvanceAmount?.type !== 'fixed' && <Typography
                        sx={{
                          marginBottom: "10px",
                        }}
                      >
                        {selectedSlot?.selectedTableSize}x Rs{venue?.reservationAdvanceAmount?.amount}
                      </Typography>}
                      <Divider sx={{ borderBottomWidth: 'initial', borderColor: "#F59B34" }} />
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          marginBottom: "10px",
                          marginTop: "10px",
                          color: "#F59B34",

                        }}
                      >
                        <Typography sx={{ fontWeight: "bold" }}>Total</Typography>
                        <Typography sx={{ fontWeight: "bold" }}>Rs {
                          venue?.reservationAdvanceAmount?.type === 'fixed' ? fNumber(venue?.reservationAdvanceAmount?.amount) : fNumber(selectedSlot?.selectedTableSize *
                            venue?.reservationAdvanceAmount?.amount)}</Typography>
                      </Box>
                    </Box>
                  </Box>}
                </Stack>


                {venue?.reservationAdvanceAmount?.isRequired &&
                  <Box
                    sx={
                      {
                        padding: 2,
                        maxWidth: 600,

                      }
                    }
                  >
                    <Box
                      sx={{
                        border: "1px solid rgba(0, 0, 0, 0.10)",
                        borderRadius: "16px",
                      }}
                    >
                      <Typography
                        variant="h5"
                        sx={{
                          fontWeight: "700",
                          fontSize: "15px",
                          padding: "16px 0px 0px 16px",
                        }}
                      >
                        Payment Methods
                      </Typography>
                      <Typography
                        sx={{
                          paddingLeft: "16px",

                        }}
                      >
                        All transactions are secure and encrypted.
                      </Typography>
                      <PaymentMethods
                        total={venue?.reservationAdvanceAmount}
                        selectedSlot={selectedSlot}
                        occasion={occasion}
                        specialRequest={specialRequest}
                      />
                    </Box>
                  </Box>
                }
                {!venue?.reservationAdvanceAmount?.isRequired &&
                  <Box
                    sx={{
                      padding: 2,
                      maxWidth: 600,
                    }}
                  >
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: "700",
                        fontSize: "15px",
                        marginBottom: "10px",
                      }}
                    >
                      Required:
                    </Typography>
                    <FormControlLabel
                      control={<Checkbox checked={checked} onChange={handleChange} sx={{ color: "orange" }} />}
                      label="I agree to the restaurant’s terms and conditions"
                    />
                  </Box>
                }
                {!venue?.reservationAdvanceAmount?.isRequired && (
                  <Box
                    sx={{
                      padding: 2,
                      maxWidth: 600,
                      marginBottom: "20px"
                    }}
                  >
                    <LoadingButton
                      fullWidth
                      color="inherit"
                      size="large"
                      type="submit"
                      variant="contained"
                      sx={{
                        marginTop: "20px",
                        bgcolor: "#F59B34",
                        color: (theme) =>
                          theme.palette.mode === "black" ? "common." : "grey.800",
                        "&:hover": {
                          bgcolor: "#B66816",
                          color: (theme) =>
                            theme.palette.mode === "black"
                              ? "common.white"
                              : "grey.800",
                        },
                      }}
                      onClick={onSubmit}
                      disabled={!checked || !user?.phone || !user?.isPhoneVerified || selectedSlot?.timeLeft <= 0}
                      loading={isLoading}
                    >
                      Complete Reservation
                    </LoadingButton>
                  </Box>
                )}
              </Grid>

              <Grid item xs={12} md={6}>
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: "700",
                    marginLeft: "14px",
                    color: "#F59B34",
                    fontSize: "20px",
                    marginBottom: "10px",
                  }}
                >
                  Booking at {venue?.name}
                </Typography>

                <Box sx={{ padding: "20px" }}>

                  <Box display="flex" alignItems="center" gap={3} marginBottom={2} >
                    <img
                      src="/assets/icons/reservation/checkoutReservation/calender.svg"
                      alt="Calendar"
                      width={20}
                      height={20} />
                    <Typography
                      sx={
                        {
                          fontWeight: "600",
                          fontSize: "14px",
                          fontFamily: "Montserrat"
                        }
                      }
                    >{formatDateInStringFormate(selectedSlot?.selectedSlot?.startingTime)}</Typography>
                  </Box>
                  <Box display="flex" alignItems="center" gap={3} marginBottom={2}>
                    <img
                      src="/assets/icons/reservation/checkoutReservation/clockIcon.svg"
                      alt="Calendar"
                      width={20}
                      height={20} />
                    <Typography
                      sx={
                        {
                          fontWeight: "600",
                          fontSize: "14px",
                          fontFamily: "Montserrat"
                        }
                      }
                    >{formatTime(selectedSlot?.selectedSlot?.startingTime)}</Typography>
                  </Box>
                  <Box display="flex" alignItems="center" gap={3} marginBottom={2}>
                    <img
                      src="/assets/icons/reservation/checkoutReservation/people.svg"
                      alt="Calendar"
                      width={20}
                      height={20} />
                    <Typography
                      sx={
                        {
                          fontWeight: "600",
                          fontSize: "14px",
                          fontFamily: "Montserrat"
                        }
                      }
                    >{selectedSlot?.selectedTableSize} People ({
                        selectedSlot?.checkView == true ?
                          selectedSlot?.selectedSlot?.areaId?.name : selectedSlot?.selectedSlot?.tableInfo?.areaId?.name
                      })</Typography>
                  </Box>
                  <Box display="flex" alignItems="center" gap={3} marginBottom={2}>
                    <img
                      src="/assets/icons/reservation/checkoutReservation/location.svg"
                      alt="Calendar"
                      width={20}
                      height={20} />
                    <Typography
                      sx={
                        {
                          fontWeight: "600",
                          fontSize: "14px",
                          fontFamily: "Montserrat"
                        }
                      }
                    >{venue?.venueAddressOne}, {venue?.venueAddressTwo}</Typography>
                  </Box>

                  <Divider sx={{ marginTop: "10px", marginBottom: "10px" }} />


                  <Box sx={{ marginTop: "10px" }}>
                    {venue?.notes && <Box sx={{ marginTop: "12px" }}>
                      <Typography variant="h6" fontWeight="bold">A note from the restaurant</Typography>
                      <Typography>
                        {showFullNote ? venue?.notes : truncateText(venue?.notes, 100)}
                      </Typography>
                      <Button onClick={() => setShowFullNote(!showFullNote)} sx={{ color: "#F59B34", textTransform: "none" }}>
                        <Icon icon={showFullNote ? minusIcon : plusIcon} width={16} height={16} /> {showFullNote ? "Read Less" : "Read More"}
                      </Button>
                    </Box>}
                    {venue?.cancellationPolicy && <Box sx={{ marginTop: "15px" }}>
                      <Typography variant="h6" fontWeight="bold">Cancellation Policy</Typography>
                      <Typography>
                        {showFullPolicy ? venue?.cancellationPolicy : truncateText(venue?.cancellationPolicy, 100)}
                      </Typography>
                      <Button onClick={() => setShowFullPolicy(!showFullPolicy)} sx={{ color: "#F59B34", textTransform: "none" }}>
                        <Icon icon={showFullPolicy ? minusIcon : plusIcon} width={16} height={16} /> {showFullPolicy ? "Read Less" : "Read More"}
                      </Button>
                    </Box>}
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Card>
        </Container>
      </Box>
    </>
  );
};
export default ReservationCheckoutSummary;
